// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EPC_rowNum__1oWm7 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--m-background-color, #f6f7fb);
  border: 1px solid var(--m-border, #d0d5dd);
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--m-text-secondary, #667085);
}

.EPC_machineCodeCell__nsHuH {
  display: inline-block;
  font-family: monospace;
  font-size: 0.8rem;
  background: rgba(0, 151, 178, 0.07);
  color: var(--m-primary, #00b4f3);
  border-radius: 4px;
  padding: 2px 7px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.EPC_machineHeader__RvOZR {
  display: flex;
  align-items: center;
  gap: 14px;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius-md, 8px);
  padding: 10px 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.EPC_backBtn__3dClj {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius, 4px);
  background: transparent;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--m-text-secondary, #667085);
  cursor: pointer;
  transition: all 0.15s;
  flex-shrink: 0;
}
.EPC_backBtn__3dClj:hover {
  background: var(--m-background-color, #f6f7fb);
  color: var(--m-text, #162949);
  border-color: var(--m-text-secondary, #667085);
}

.EPC_machineInfo__EWDcA {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
}

.EPC_machineIcon__CSa73 {
  display: flex;
  align-items: center;
  color: var(--m-primary, #00b4f3);
}

.EPC_machineName__PwIHK {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--m-text, #162949);
}

.EPC_machineCode__1ZmvM {
  font-family: monospace;
  font-size: 0.75rem;
  background: rgba(0, 151, 178, 0.08);
  color: var(--m-primary, #00b4f3);
  border-radius: 4px;
  padding: 1px 6px;
  font-weight: 600;
}

.EPC_breadcrumb__OSFtp {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
@media (max-width: 480px) {
  .EPC_breadcrumb__OSFtp {
    display: none;
  }
}

.EPC_bcActive__9a3dU {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--m-primary, #00b4f3);
}

.EPC_bcInactive__KISm5 {
  font-size: 0.75rem;
  color: var(--m-text-secondary, #667085);
}

.EPC_bcSep__40zps {
  color: var(--m-border, #d0d5dd);
}

.EPC_actionGrid__Cj7Q6 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
@media (max-width: 900px) {
  .EPC_actionGrid__Cj7Q6 {
    grid-template-columns: 1fr;
    max-width: 480px;
    margin: 0 auto;
  }
}

.EPC_actionCard__LXHIu {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 24px 28px;
  background: var(--m-card-background-color, #fff);
  border: 1.5px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius-md, 8px);
  cursor: pointer;
  transition: all 0.18s ease;
  position: relative;
  text-align: center;
}
.EPC_actionCard__LXHIu:hover {
  border-color: var(--accent-color, #00b4f3);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}
.EPC_actionCard__LXHIu:hover .EPC_actionArrow__4WbUZ {
  transform: translateX(4px);
}
.EPC_actionCard__LXHIu:active {
  transform: translateY(0);
  box-shadow: none;
}

.EPC_actionIconWrap__HzUrY {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.18s;
}
.EPC_actionCard__LXHIu:hover .EPC_actionIconWrap__HzUrY {
  transform: scale(1.06);
}

.EPC_actionCardBody__YGI2L {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

.EPC_actionTitle__OfnpN {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.EPC_actionDesc__nmzpd {
  font-size: 0.8rem;
  color: var(--m-text-secondary, #667085);
  line-height: 1.5;
  max-width: 220px;
}

.EPC_actionArrow__4WbUZ {
  display: flex;
  align-items: center;
  transition: transform 0.18s ease;
}

.EPC_formCard__jMo\\+r {
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius-md, 8px);
  overflow: visible;
  width: 100%;
}

.EPC_formCardHeader__jUukI {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: color-mix(in srgb, var(--accent, #00b4f3) 6%, var(--m-background-color, #f6f7fb));
  border-bottom: 1px solid var(--m-border, #d0d5dd);
}

.EPC_formCardIcon__nYz1E {
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background: rgba(0, 151, 178, 0.12);
  color: var(--m-primary, #00b4f3);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.EPC_formCardTitle__6VTQi {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--m-primary, #00b4f3);
}

.EPC_formCardSub__Tb51g {
  font-size: 0.78rem;
  color: var(--m-text-secondary, #667085);
  margin-top: 1px;
}

.EPC_formBody__oC2Fc {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.EPC_formBodyHorizontal__aAPqE .EPC_formRow__\\+PMC- {
  align-items: flex-end;
}

.EPC_formRow__\\+PMC- {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 580px) {
  .EPC_formRow__\\+PMC- {
    grid-template-columns: 1fr;
  }
}

.EPC_formFooter__glKd3 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  background: var(--m-background-color, #f6f7fb);
  border-top: 1px solid var(--m-border, #d0d5dd);
}

.EPC_field__ipf\\+3 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.EPC_fieldLabel__ev7Am {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--m-text, #162949);
}

.EPC_req__dohR0 {
  color: var(--m-danger, #ca371c);
  margin-left: 2px;
}

.EPC_emptyOpts__55HKY {
  font-size: 0.82rem;
  color: var(--m-text-secondary, #667085);
  padding: 9px 12px;
  background: var(--m-background-color, #f6f7fb);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius, 4px);
  font-style: italic;
}

.EPC_readonlyValue__sHtDM {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 12px;
  background: var(--m-background-color, #f6f7fb);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius, 4px);
}
.EPC_readonlyValue__sHtDM strong {
  font-size: 1rem;
  font-weight: 700;
  color: var(--m-primary, #00b4f3);
}

.EPC_readonlyUnit__-5o8F {
  font-size: 0.75rem;
  color: var(--m-text-secondary, #667085);
}

.EPC_readonlyLoading__zgYfY {
  font-size: 0.8rem;
  color: var(--m-text-secondary, #667085);
  font-style: italic;
}

.EPC_stopPreview__J2YZ9 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  background: rgba(217, 119, 6, 0.06);
  border: 1px solid rgba(217, 119, 6, 0.2);
  border-radius: var(--m-border-radius, 4px);
}

.EPC_stopPreviewItem__mvLyT {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 120px;
}
.EPC_stopPreviewItem__mvLyT span {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--m-text-secondary, #667085);
}
.EPC_stopPreviewItem__mvLyT strong {
  font-size: 0.82rem;
  color: var(--m-text, #162949);
}

.EPC_native__7YAQL {
  height: 38px;
  width: 100%;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius, 4px);
  padding: 0 10px;
  font-size: 13px;
  color: var(--m-text, #162949);
  outline: none;
  transition: border-color 0.15s;
}
.EPC_native__7YAQL:focus {
  border-color: var(--m-primary, #00b4f3);
  box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.1);
}

.EPC_sel__0VSId {
  position: relative;
}
.EPC_sel__0VSId select {
  appearance: none;
  width: 100%;
  height: 38px;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius, 4px);
  padding: 0 32px 0 10px;
  font-size: 13px;
  color: var(--m-text, #162949);
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
}
.EPC_sel__0VSId select:focus {
  border-color: var(--m-primary, #00b4f3);
  box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.1);
}
.EPC_sel__0VSId::after {
  content: "";
  pointer-events: none;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid var(--m-text-secondary, #667085);
}

.EPC_srchWrap__5fhtc {
  position: relative;
}
.EPC_srchWrap__5fhtc:has(.EPC_srchOpen__jEywM) {
  z-index: 20;
}

.EPC_srchBtn__AG2AD {
  width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius, 4px);
  font-size: 13px;
  color: var(--m-text, #162949);
  cursor: pointer;
  text-align: left;
  gap: 6px;
  transition: border-color 0.15s;
}
.EPC_srchBtn__AG2AD:hover, .EPC_srchBtn__AG2AD.EPC_srchOpen__jEywM {
  border-color: var(--m-primary, #00b4f3);
}
.EPC_srchBtn__AG2AD.EPC_srchOpen__jEywM {
  box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.1);
}
.EPC_srchBtn__AG2AD.EPC_srchFilled__aNwea {
  border-left: 2px solid var(--m-primary, #00b4f3);
}

.EPC_srchPlaceholder__TsEHd {
  color: var(--m-text-secondary, #667085);
  font-size: 12px;
}

.EPC_srchVal__zfh0E {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  overflow: hidden;
}
.EPC_srchVal__zfh0E strong {
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.EPC_srchVal__zfh0E em {
  font-style: normal;
  font-size: 0.72rem;
  font-family: monospace;
  color: var(--m-text-secondary, #667085);
  background: var(--m-background-color, #f6f7fb);
  border-radius: 3px;
  padding: 0 4px;
  white-space: nowrap;
}

.EPC_srchChev__s9XJ1 {
  flex-shrink: 0;
  color: var(--m-text-secondary, #667085);
  transition: transform 0.2s;
}
.EPC_srchChev__s9XJ1.EPC_rotated__3t70n {
  transform: rotate(180deg);
}

.EPC_srchPanel__1DSvw {
  position: absolute;
  top: calc(100% + 3px);
  left: 0;
  right: 0;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  z-index: 300;
  overflow: hidden;
}

.EPC_srchInput__6IjAM {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  border-bottom: 1px solid var(--m-border, #d0d5dd);
  color: var(--m-text-secondary, #667085);
}
.EPC_srchInput__6IjAM input {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  color: inherit;
}
.EPC_srchInput__6IjAM input::placeholder {
  color: var(--m-text-secondary, #667085);
}

.EPC_srchList__eQedA {
  max-height: 220px;
  overflow-y: auto;
}

.EPC_srchEmpty__M6Ws7 {
  padding: 12px;
  text-align: center;
  font-size: 0.8rem;
  color: var(--m-text-secondary, #667085);
}

.EPC_srchItem__NGXcV {
  display: flex;
  flex-direction: column;
  gap: 1px;
  width: 100%;
  text-align: left;
  padding: 8px 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  position: relative;
  transition: background 0.1s;
}
.EPC_srchItem__NGXcV:hover {
  background: var(--m-background-color, #f6f7fb);
}
.EPC_srchItem__NGXcV.EPC_srchSelected__-UxGF {
  background: rgba(0, 151, 178, 0.06);
}

.EPC_srchItemMain__rYs4B {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--m-text, #162949);
}

.EPC_srchItemSub__gVMmI {
  font-size: 0.72rem;
  color: var(--m-text-secondary, #667085);
}

.EPC_srchCheck__LdbrQ {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--m-primary, #00b4f3);
}

.EPC_loadingForm__RPbju {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px;
  font-size: 0.875rem;
  color: var(--m-text-secondary, #667085);
}

@keyframes EPC_spin__XQQIT {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.EPC_spin__XQQIT {
  animation: EPC_spin__XQQIT 1s linear infinite;
}

.EPC_successWrap__eGGi9 {
  display: flex;
  justify-content: center;
  padding: 16px 0 32px;
}

.EPC_successCard__r1Dmd {
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius-md, 8px);
  box-shadow: var(--m-header-box-shadow, 0 1px 2px rgba(16, 24, 40, 0.06));
  padding: 28px 24px 24px;
  width: 100%;
  max-width: 480px;
}

.EPC_successHeader__HwSSa {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
}

.EPC_successIconWrap__6YXtP {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(3, 158, 104, 0.1);
  color: var(--m-success, #039e68);
}

.EPC_successHeaderText__oCX7j {
  flex: 1 1;
  min-width: 0;
  padding-top: 2px;
}

.EPC_successTitle__8uJBW {
  font-size: 1rem;
  font-weight: 700;
  color: var(--m-text, #162949);
  margin: 0 0 6px;
  line-height: 1.35;
}

.EPC_successMsg__vzNAo {
  font-size: 0.8125rem;
  color: var(--m-text-secondary, #667085);
  margin: 0;
  line-height: 1.5;
}

.EPC_successMeta__c6OIM {
  display: flex;
  align-items: stretch;
  gap: 0;
  padding: 0;
  background: var(--m-background-color, #f6f7fb);
  border: 1px solid var(--m-border, #e4e7ec);
  border-radius: 6px;
  margin-bottom: 20px;
  overflow: hidden;
}

.EPC_successMetaItem__-6i3e {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
  padding: 12px 14px;
}

.EPC_successMetaDivider__05kIL {
  width: 1px;
  background: var(--m-border, #e4e7ec);
  flex-shrink: 0;
}

.EPC_successMetaLabel__sh7RK {
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--m-text-secondary, #667085);
  line-height: 1.2;
}

.EPC_successMetaValue__mjRnj {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--m-text, #162949);
  line-height: 1.35;
  min-width: 0;
}
.EPC_successMetaValue__mjRnj span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.EPC_successActions__j1D\\+4 {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.EPC_successActionsDivider__QxEdo {
  height: 1px;
  background: var(--m-border, #e4e7ec);
  margin: 16px 0;
}

.EPC_successActionsSecondary__M\\+mXt {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.EPC_successActionsPair__972dG {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

@media (max-width: 480px) {
  .EPC_successActionsPair__972dG {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 480px) {
  .EPC_successCard__r1Dmd {
    padding: 22px 16px 18px;
  }
  .EPC_successMeta__c6OIM {
    flex-direction: column;
  }
  .EPC_successMetaDivider__05kIL {
    width: 100%;
    height: 1px;
  }
}
.EPC_machineGrid__SN09K {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 16px;
}

.EPC_machineCard__nLjje {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius-md, 12px);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: visible;
}
.EPC_machineCard__nLjje:hover {
  border-color: var(--m-primary, #00b4f3);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}
.EPC_machineCard__nLjje:hover .EPC_machineCardIconWrap__T9fKF {
  background: rgba(0, 151, 178, 0.12);
  color: var(--m-primary, #00b4f3);
}
.EPC_machineCard__nLjje:active {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.EPC_machineCardHeader__HwAs- {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.EPC_machineCardIconWrap__T9fKF {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: var(--m-background-color, #f6f7fb);
  color: var(--m-text-secondary, #667085);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.EPC_machineCardCode__PhTHK {
  font-family: monospace;
  font-size: 0.75rem;
  background: rgba(0, 151, 178, 0.08);
  color: var(--m-primary, #00b4f3);
  border-radius: 4px;
  padding: 2px 8px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.EPC_machineCardBody__vrg5L {
  margin-bottom: 16px;
  flex-grow: 1;
}

.EPC_machineCardName__d2zeE {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--m-text, #162949);
  line-height: 1.3;
  margin: 0;
}

.EPC_machineCardActions__eHeBz {
  border-top: 1px dashed var(--m-border, #d0d5dd);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

.EPC_miniActionBtn__4uGUq {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: var(--btn-bg, rgba(0, 151, 178, 0.08));
  color: var(--btn-color, var(--m-primary, #00b4f3));
  cursor: pointer;
  transition: all 0.2s ease;
}
.EPC_miniActionBtn__4uGUq:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px var(--shadow-color, rgba(0, 151, 178, 0.15));
  border-color: var(--btn-color);
}
.EPC_miniActionBtn__4uGUq:active {
  transform: translateY(0);
}
.EPC_miniActionBtn__4uGUq[data-tooltip]::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-6px);
  background: #1e293b;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.15s ease;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: none;
}
.EPC_miniActionBtn__4uGUq[data-tooltip]:hover::before {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(-2px);
}

.EPC_searchBarContainer__MJMqR {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.EPC_searchBarInputWrap__sVEPo {
  position: relative;
  flex: 1 1;
  max-width: 400px;
}

.EPC_searchBarIcon__aie8S {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--m-text-secondary, #667085);
  display: flex;
  align-items: center;
  pointer-events: none;
}

.EPC_searchBarInput__F2pmt {
  width: 100%;
  height: 38px;
  padding: 0 16px 0 36px;
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 8px;
  font-size: 0.85rem;
  background: var(--m-card-background-color, #fff);
  color: var(--m-text, #162949);
  outline: none;
  transition: all 0.15s ease;
}
.EPC_searchBarInput__F2pmt:focus {
  border-color: var(--m-primary, #00b4f3);
  box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.1);
}

.EPC_noMachinesFound__gHhpM {
  text-align: center;
  padding: 40px;
  color: var(--m-text-secondary, #667085);
  font-size: 0.9rem;
  background: var(--m-card-background-color, #fff);
  border: 1px dashed var(--m-border, #d0d5dd);
  border-radius: var(--m-border-radius-md, 8px);
}

.EPC_producingPartText__K4v\\+O {
  display: inline-block;
  margin-top: 8px;
  font-size: 13px;
  color: var(--m-text, #162949);
  font-weight: 500;
  cursor: help;
  transition: all 0.25s ease;
}
.EPC_producingPartText__K4v\\+O:hover {
  color: var(--m-primary, #00b4f3);
}

.EPC_producingPartTextSingle__H1oH5 {
  margin-top: 8px;
  font-size: 13px;
  color: var(--m-text, #162949);
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/EPC/EPC.module.scss"],"names":[],"mappings":"AACA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;AAAF;;AAGA;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAAF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gDAAA;EACA,0CAAA;EACA,6CAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,0CAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uCAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AADF;AAGE;EACE,8CAAA;EACA,6BAAA;EACA,8CAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AAFF;;AAKA;EACE,iBAAA;EACA,gBAAA;EACA,6BAAA;AAFF;;AAKA;EACE,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAFF;AAIE;EANF;IAOI,aAAA;EADF;AACF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;AADF;;AAIA;EACE,kBAAA;EACA,uCAAA;AADF;;AAIA;EACE,+BAAA;AADF;;AAKA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAFF;AAIE;EALF;IAMI,0BAAA;IACA,gBAAA;IACA,cAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,gDAAA;EACA,4CAAA;EACA,6CAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAGE;EACE,0CAAA;EACA,0CAAA;EACA,2BAAA;AADJ;AAGI;EACE,0BAAA;AADN;AAKE;EACE,wBAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAJF;AAME;EACE,sBAAA;AAJJ;;AAQA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AALF;;AAQA;EACE,iBAAA;EACA,uCAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AALF;;AASA;EACE,gDAAA;EACA,0CAAA;EACA,6CAAA;EACA,iBAAA;EACA,WAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6FAAA;EAKA,iDAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;AAVF;;AAaA;EACE,kBAAA;EACA,uCAAA;EACA,eAAA;AAVF;;AAaA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAVF;;AAcE;EACE,qBAAA;AAXJ;;AAeA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAZF;AAcE;EALF;IAMI,0BAAA;EAXF;AACF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,8CAAA;EACA,8CAAA;AAXF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAZF;;AAeA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,6BAAA;AAZF;;AAeA;EACE,+BAAA;EACA,gBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,uCAAA;EACA,iBAAA;EACA,8CAAA;EACA,0CAAA;EACA,0CAAA;EACA,kBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,8CAAA;EACA,0CAAA;EACA,0CAAA;AAZF;AAcE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;AAZJ;;AAgBA;EACE,kBAAA;EACA,uCAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,uCAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,mCAAA;EACA,wCAAA;EACA,0CAAA;AAbF;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAbF;AAeE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uCAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,6BAAA;AAdJ;;AAmBA;EACE,YAAA;EACA,WAAA;EACA,gDAAA;EACA,0CAAA;EACA,0CAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;AAhBF;AAkBE;EACE,uCAAA;EACA,4CAAA;AAhBJ;;AAqBA;EACE,kBAAA;AAlBF;AAoBE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,0CAAA;EACA,0CAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;AAlBJ;AAoBI;EACE,uCAAA;EACA,4CAAA;AAlBN;AAsBE;EACE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;EACA,sDAAA;AApBJ;;AAyBA;EACE,kBAAA;AAtBF;AAwBE;EACE,WAAA;AAtBJ;;AA0BA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gDAAA;EACA,0CAAA;EACA,0CAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,8BAAA;AAvBF;AAyBE;EAEE,uCAAA;AAxBJ;AA0BE;EACE,4CAAA;AAxBJ;AA0BE;EACE,gDAAA;AAxBJ;;AA4BA;EACE,uCAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AAzBF;AA2BE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzBJ;AA2BE;EACE,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uCAAA;EACA,8CAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAzBJ;;AA6BA;EACE,cAAA;EACA,uCAAA;EACA,0BAAA;AA1BF;AA2BE;EACE,yBAAA;AAzBJ;;AA6BA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,gDAAA;EACA,0CAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,iDAAA;EACA,uCAAA;AA1BF;AA4BE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AA1BJ;AA2BI;EACE,uCAAA;AAzBN;;AA8BA;EACE,iBAAA;EACA,gBAAA;AA3BF;;AA6BA;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,uCAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;AA1BF;AA4BE;EACE,8CAAA;AA1BJ;AA4BE;EACE,mCAAA;AA1BJ;;AA8BA;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;AA3BF;;AA6BA;EACE,kBAAA;EACA,uCAAA;AA1BF;;AA4BA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gCAAA;AAzBF;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uCAAA;AA1BF;;AA6BA;EACE;IACE,uBAAA;EA1BF;EA4BA;IACE,yBAAA;EA1BF;AACF;AA6BA;EACE,6CAAA;AA3BF;;AA+BA;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;AA5BF;;AA+BA;EACE,gDAAA;EACA,0CAAA;EACA,6CAAA;EACA,wEAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AA5BF;;AA+BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kCAAA;EACA,gCAAA;AA5BF;;AA+BA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AA5BF;;AA+BA;EACE,oBAAA;EACA,uCAAA;EACA,SAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,oBAAA;EACA,MAAA;EACA,UAAA;EACA,8CAAA;EACA,0CAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AA5BF;;AA+BA;EACE,UAAA;EACA,oCAAA;EACA,cAAA;AA5BF;;AA+BA;EACE,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uCAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;AA5BF;AA8BE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA5BJ;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AA7BF;;AAgCA;EACE,WAAA;EACA,oCAAA;EACA,cAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AA7BF;;AAgCA;EACE;IACE,0BAAA;EA7BF;AACF;AAgCA;EACE;IACE,uBAAA;EA9BF;EAiCA;IACE,sBAAA;EA/BF;EAkCA;IACE,WAAA;IACA,WAAA;EAhCF;AACF;AAoCA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAlCF;;AAqCA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,gDAAA;EACA,0CAAA;EACA,8CAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,iBAAA;AAlCF;AAoCE;EACE,uCAAA;EACA,0CAAA;EACA,2BAAA;AAlCJ;AAoCI;EACE,mCAAA;EACA,gCAAA;AAlCN;AAsCE;EACE,2BAAA;EACA,0CAAA;AApCJ;;AAwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AArCF;;AAwCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AArCF;;AAwCA;EACE,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AArCF;;AAwCA;EACE,mBAAA;EACA,YAAA;AArCF;;AAwCA;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;AArCF;;AAwCA;EACE,+CAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAtCF;;AAyCA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,kDAAA;EACA,kDAAA;EACA,eAAA;EACA,yBAAA;AAtCF;AAwCE;EACE,2BAAA;EACA,mEAAA;EACA,8BAAA;AAtCJ;AAyCE;EACE,wBAAA;AAvCJ;AA2CE;EACE,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,4CAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,0CAAA;EACA,oBAAA;AAzCJ;AA4CE;EACE,UAAA;EACA,mBAAA;EACA,4CAAA;AA1CJ;;AA8CA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AA3CF;;AA8CA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;AA3CF;;AA8CA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AA3CF;;AA8CA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,0CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gDAAA;EACA,6BAAA;EACA,aAAA;EACA,0BAAA;AA3CF;AA6CE;EACE,uCAAA;EACA,4CAAA;AA3CJ;;AA+CA;EACE,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,iBAAA;EACA,gDAAA;EACA,2CAAA;EACA,6CAAA;AA5CF;;AA+CA;EACE,qBAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;AA5CF;AA8CE;EACE,gCAAA;AA5CJ;;AAiDA;EACE,eAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;AA9CF","sourcesContent":["// ─── Machine table cell ───────────────────────────────────────────────────────\n.rowNum {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--m-background-color, #f6f7fb);\n  border: 1px solid var(--m-border, #d0d5dd);\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--m-text-secondary, #667085);\n}\n\n.machineCodeCell {\n  display: inline-block;\n  font-family: monospace;\n  font-size: 0.8rem;\n  background: rgba(0, 151, 178, 0.07);\n  color: var(--m-primary, #00b4f3);\n  border-radius: 4px;\n  padding: 2px 7px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n// ─── Machine header bar ───────────────────────────────────────────────────────\n.machineHeader {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius-md, 8px);\n  padding: 10px 16px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.backBtn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 10px;\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius, 4px);\n  background: transparent;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--m-text-secondary, #667085);\n  cursor: pointer;\n  transition: all 0.15s;\n  flex-shrink: 0;\n\n  &:hover {\n    background: var(--m-background-color, #f6f7fb);\n    color: var(--m-text, #162949);\n    border-color: var(--m-text-secondary, #667085);\n  }\n}\n\n.machineInfo {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n}\n\n.machineIcon {\n  display: flex;\n  align-items: center;\n  color: var(--m-primary, #00b4f3);\n}\n\n.machineName {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--m-text, #162949);\n}\n\n.machineCode {\n  font-family: monospace;\n  font-size: 0.75rem;\n  background: rgba(0, 151, 178, 0.08);\n  color: var(--m-primary, #00b4f3);\n  border-radius: 4px;\n  padding: 1px 6px;\n  font-weight: 600;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n\n  @media (max-width: 480px) {\n    display: none;\n  }\n}\n\n.bcActive {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--m-primary, #00b4f3);\n}\n\n.bcInactive {\n  font-size: 0.75rem;\n  color: var(--m-text-secondary, #667085);\n}\n\n.bcSep {\n  color: var(--m-border, #d0d5dd);\n}\n\n// ─── Action Card Grid ─────────────────────────────────────────────────────────\n.actionGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n    max-width: 480px;\n    margin: 0 auto;\n  }\n}\n\n.actionCard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 32px 24px 28px;\n  background: var(--m-card-background-color, #fff);\n  border: 1.5px solid var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius-md, 8px);\n  cursor: pointer;\n  transition: all 0.18s ease;\n  position: relative;\n  text-align: center;\n\n  &:hover {\n    border-color: var(--accent-color, #00b4f3);\n    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);\n    transform: translateY(-2px);\n\n    .actionArrow {\n      transform: translateX(4px);\n    }\n  }\n\n  &:active {\n    transform: translateY(0);\n    box-shadow: none;\n  }\n}\n\n.actionIconWrap {\n  width: 72px;\n  height: 72px;\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.18s;\n\n  .actionCard:hover & {\n    transform: scale(1.06);\n  }\n}\n\n.actionCardBody {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: center;\n}\n\n.actionTitle {\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n}\n\n.actionDesc {\n  font-size: 0.8rem;\n  color: var(--m-text-secondary, #667085);\n  line-height: 1.5;\n  max-width: 220px;\n}\n\n.actionArrow {\n  display: flex;\n  align-items: center;\n  transition: transform 0.18s ease;\n}\n\n// ─── Form Card ────────────────────────────────────────────────────────────────\n.formCard {\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius-md, 8px);\n  overflow: visible;\n  width: 100%;\n}\n\n.formCardHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: color-mix(\n    in srgb,\n    var(--accent, #00b4f3) 6%,\n    var(--m-background-color, #f6f7fb)\n  );\n  border-bottom: 1px solid var(--m-border, #d0d5dd);\n}\n\n.formCardIcon {\n  width: 38px;\n  height: 38px;\n  border-radius: 9px;\n  background: rgba(0, 151, 178, 0.12);\n  color: var(--m-primary, #00b4f3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.formCardTitle {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--m-primary, #00b4f3);\n}\n\n.formCardSub {\n  font-size: 0.78rem;\n  color: var(--m-text-secondary, #667085);\n  margin-top: 1px;\n}\n\n.formBody {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.formBodyHorizontal {\n  .formRow {\n    align-items: flex-end;\n  }\n}\n\n.formRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n\n  @media (max-width: 580px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.formFooter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 20px;\n  background: var(--m-background-color, #f6f7fb);\n  border-top: 1px solid var(--m-border, #d0d5dd);\n}\n\n// ─── Field ────────────────────────────────────────────────────────────────────\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.fieldLabel {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--m-text, #162949);\n}\n\n.req {\n  color: var(--m-danger, #ca371c);\n  margin-left: 2px;\n}\n\n.emptyOpts {\n  font-size: 0.82rem;\n  color: var(--m-text-secondary, #667085);\n  padding: 9px 12px;\n  background: var(--m-background-color, #f6f7fb);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius, 4px);\n  font-style: italic;\n}\n\n.readonlyValue {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 38px;\n  padding: 0 12px;\n  background: var(--m-background-color, #f6f7fb);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius, 4px);\n\n  strong {\n    font-size: 1rem;\n    font-weight: 700;\n    color: var(--m-primary, #00b4f3);\n  }\n}\n\n.readonlyUnit {\n  font-size: 0.75rem;\n  color: var(--m-text-secondary, #667085);\n}\n\n.readonlyLoading {\n  font-size: 0.8rem;\n  color: var(--m-text-secondary, #667085);\n  font-style: italic;\n}\n\n.stopPreview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 12px 14px;\n  background: rgba(217, 119, 6, 0.06);\n  border: 1px solid rgba(217, 119, 6, 0.2);\n  border-radius: var(--m-border-radius, 4px);\n}\n\n.stopPreviewItem {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 120px;\n\n  span {\n    font-size: 0.68rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: var(--m-text-secondary, #667085);\n  }\n\n  strong {\n    font-size: 0.82rem;\n    color: var(--m-text, #162949);\n  }\n}\n\n// ─── Native input ─────────────────────────────────────────────────────────────\n.native {\n  height: 38px;\n  width: 100%;\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius, 4px);\n  padding: 0 10px;\n  font-size: 13px;\n  color: var(--m-text, #162949);\n  outline: none;\n  transition: border-color 0.15s;\n\n  &:focus {\n    border-color: var(--m-primary, #00b4f3);\n    box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.1);\n  }\n}\n\n// ─── Styled select ────────────────────────────────────────────────────────────\n.sel {\n  position: relative;\n\n  select {\n    appearance: none;\n    width: 100%;\n    height: 38px;\n    background: var(--m-card-background-color, #fff);\n    border: 1px solid var(--m-border, #d0d5dd);\n    border-radius: var(--m-border-radius, 4px);\n    padding: 0 32px 0 10px;\n    font-size: 13px;\n    color: var(--m-text, #162949);\n    cursor: pointer;\n    outline: none;\n    transition: border-color 0.15s;\n\n    &:focus {\n      border-color: var(--m-primary, #00b4f3);\n      box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.1);\n    }\n  }\n\n  &::after {\n    content: \"\";\n    pointer-events: none;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n    border-top: 5px solid var(--m-text-secondary, #667085);\n  }\n}\n\n// ─── Searchable select ────────────────────────────────────────────────────────\n.srchWrap {\n  position: relative;\n\n  &:has(.srchOpen) {\n    z-index: 20;\n  }\n}\n\n.srchBtn {\n  width: 100%;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius, 4px);\n  font-size: 13px;\n  color: var(--m-text, #162949);\n  cursor: pointer;\n  text-align: left;\n  gap: 6px;\n  transition: border-color 0.15s;\n\n  &:hover,\n  &.srchOpen {\n    border-color: var(--m-primary, #00b4f3);\n  }\n  &.srchOpen {\n    box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.1);\n  }\n  &.srchFilled {\n    border-left: 2px solid var(--m-primary, #00b4f3);\n  }\n}\n\n.srchPlaceholder {\n  color: var(--m-text-secondary, #667085);\n  font-size: 12px;\n}\n\n.srchVal {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n  overflow: hidden;\n\n  strong {\n    font-size: 0.82rem;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  em {\n    font-style: normal;\n    font-size: 0.72rem;\n    font-family: monospace;\n    color: var(--m-text-secondary, #667085);\n    background: var(--m-background-color, #f6f7fb);\n    border-radius: 3px;\n    padding: 0 4px;\n    white-space: nowrap;\n  }\n}\n\n.srchChev {\n  flex-shrink: 0;\n  color: var(--m-text-secondary, #667085);\n  transition: transform 0.2s;\n  &.rotated {\n    transform: rotate(180deg);\n  }\n}\n\n.srchPanel {\n  position: absolute;\n  top: calc(100% + 3px);\n  left: 0;\n  right: 0;\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: 6px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  z-index: 300;\n  overflow: hidden;\n}\n\n.srchInput {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 10px;\n  border-bottom: 1px solid var(--m-border, #d0d5dd);\n  color: var(--m-text-secondary, #667085);\n\n  input {\n    flex: 1;\n    border: none;\n    outline: none;\n    background: transparent;\n    font-size: 12px;\n    color: inherit;\n    &::placeholder {\n      color: var(--m-text-secondary, #667085);\n    }\n  }\n}\n\n.srchList {\n  max-height: 220px;\n  overflow-y: auto;\n}\n.srchEmpty {\n  padding: 12px;\n  text-align: center;\n  font-size: 0.8rem;\n  color: var(--m-text-secondary, #667085);\n}\n\n.srchItem {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  width: 100%;\n  text-align: left;\n  padding: 8px 10px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  position: relative;\n  transition: background 0.1s;\n\n  &:hover {\n    background: var(--m-background-color, #f6f7fb);\n  }\n  &.srchSelected {\n    background: rgba(0, 151, 178, 0.06);\n  }\n}\n\n.srchItemMain {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--m-text, #162949);\n}\n.srchItemSub {\n  font-size: 0.72rem;\n  color: var(--m-text-secondary, #667085);\n}\n.srchCheck {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--m-primary, #00b4f3);\n}\n\n// ─── Loading ──────────────────────────────────────────────────────────────────\n.loadingForm {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 40px;\n  font-size: 0.875rem;\n  color: var(--m-text-secondary, #667085);\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n// ─── Success view ─────────────────────────────────────────────────────────────\n.successWrap {\n  display: flex;\n  justify-content: center;\n  padding: 16px 0 32px;\n}\n\n.successCard {\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius-md, 8px);\n  box-shadow: var(--m-header-box-shadow, 0 1px 2px rgba(16, 24, 40, 0.06));\n  padding: 28px 24px 24px;\n  width: 100%;\n  max-width: 480px;\n}\n\n.successHeader {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n.successIconWrap {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: rgba(3, 158, 104, 0.1);\n  color: var(--m-success, #039e68);\n}\n\n.successHeaderText {\n  flex: 1;\n  min-width: 0;\n  padding-top: 2px;\n}\n\n.successTitle {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--m-text, #162949);\n  margin: 0 0 6px;\n  line-height: 1.35;\n}\n\n.successMsg {\n  font-size: 0.8125rem;\n  color: var(--m-text-secondary, #667085);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.successMeta {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  padding: 0;\n  background: var(--m-background-color, #f6f7fb);\n  border: 1px solid var(--m-border, #e4e7ec);\n  border-radius: 6px;\n  margin-bottom: 20px;\n  overflow: hidden;\n}\n\n.successMetaItem {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n  padding: 12px 14px;\n}\n\n.successMetaDivider {\n  width: 1px;\n  background: var(--m-border, #e4e7ec);\n  flex-shrink: 0;\n}\n\n.successMetaLabel {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--m-text-secondary, #667085);\n  line-height: 1.2;\n}\n\n.successMetaValue {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--m-text, #162949);\n  line-height: 1.35;\n  min-width: 0;\n\n  span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.successActions {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.successActionsDivider {\n  height: 1px;\n  background: var(--m-border, #e4e7ec);\n  margin: 16px 0;\n}\n\n.successActionsSecondary {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.successActionsPair {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n@media (max-width: 480px) {\n  .successActionsPair {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .successCard {\n    padding: 22px 16px 18px;\n  }\n\n  .successMeta {\n    flex-direction: column;\n  }\n\n  .successMetaDivider {\n    width: 100%;\n    height: 1px;\n  }\n}\n\n// ─── Machine Cards Grid ───────────────────────────────────────────────────────\n.machineGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n  margin-top: 16px;\n}\n\n.machineCard {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 20px;\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius-md, 12px);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: visible;\n\n  &:hover {\n    border-color: var(--m-primary, #00b4f3);\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);\n    transform: translateY(-3px);\n\n    .machineCardIconWrap {\n      background: rgba(0, 151, 178, 0.12);\n      color: var(--m-primary, #00b4f3);\n    }\n  }\n\n  &:active {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n  }\n}\n\n.machineCardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.machineCardIconWrap {\n  width: 38px;\n  height: 38px;\n  border-radius: 8px;\n  background: var(--m-background-color, #f6f7fb);\n  color: var(--m-text-secondary, #667085);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.machineCardCode {\n  font-family: monospace;\n  font-size: 0.75rem;\n  background: rgba(0, 151, 178, 0.08);\n  color: var(--m-primary, #00b4f3);\n  border-radius: 4px;\n  padding: 2px 8px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n.machineCardBody {\n  margin-bottom: 16px;\n  flex-grow: 1;\n}\n\n.machineCardName {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--m-text, #162949);\n  line-height: 1.3;\n  margin: 0;\n}\n\n.machineCardActions {\n  border-top: 1px dashed var(--m-border, #d0d5dd);\n  // padding-top: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n}\n\n.miniActionBtn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  background: var(--btn-bg, rgba(0, 151, 178, 0.08));\n  color: var(--btn-color, var(--m-primary, #00b4f3));\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 10px var(--shadow-color, rgba(0, 151, 178, 0.15));\n    border-color: var(--btn-color);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n\n  // Tooltip\n  &[data-tooltip]::before {\n    content: attr(data-tooltip);\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-6px);\n    background: #1e293b;\n    color: #fff;\n    font-size: 0.65rem;\n    font-weight: 600;\n    padding: 4px 8px;\n    border-radius: 4px;\n    white-space: nowrap;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.15s ease;\n    z-index: 10;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    pointer-events: none;\n  }\n\n  &[data-tooltip]:hover::before {\n    opacity: 1;\n    visibility: visible;\n    transform: translateX(-50%) translateY(-2px);\n  }\n}\n\n.searchBarContainer {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 12px;\n}\n\n.searchBarInputWrap {\n  position: relative;\n  flex: 1;\n  max-width: 400px;\n}\n\n.searchBarIcon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--m-text-secondary, #667085);\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n}\n\n.searchBarInput {\n  width: 100%;\n  height: 38px;\n  padding: 0 16px 0 36px;\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: 8px;\n  font-size: 0.85rem;\n  background: var(--m-card-background-color, #fff);\n  color: var(--m-text, #162949);\n  outline: none;\n  transition: all 0.15s ease;\n\n  &:focus {\n    border-color: var(--m-primary, #00b4f3);\n    box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.1);\n  }\n}\n\n.noMachinesFound {\n  text-align: center;\n  padding: 40px;\n  color: var(--m-text-secondary, #667085);\n  font-size: 0.9rem;\n  background: var(--m-card-background-color, #fff);\n  border: 1px dashed var(--m-border, #d0d5dd);\n  border-radius: var(--m-border-radius-md, 8px);\n}\n\n.producingPartText {\n  display: inline-block;\n  margin-top: 8px;\n  font-size: 13px;\n  color: var(--m-text, #162949);\n  font-weight: 500;\n  cursor: help;\n  transition: all 0.25s ease;\n\n  &:hover {\n    color: var(--m-primary, #00b4f3);\n    // transform: translateX(4px) scale(1.02);\n  }\n}\n\n.producingPartTextSingle {\n  margin-top: 8px;\n  font-size: 13px;\n  color: var(--m-text, #162949);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rowNum": `EPC_rowNum__1oWm7`,
	"machineCodeCell": `EPC_machineCodeCell__nsHuH`,
	"machineHeader": `EPC_machineHeader__RvOZR`,
	"backBtn": `EPC_backBtn__3dClj`,
	"machineInfo": `EPC_machineInfo__EWDcA`,
	"machineIcon": `EPC_machineIcon__CSa73`,
	"machineName": `EPC_machineName__PwIHK`,
	"machineCode": `EPC_machineCode__1ZmvM`,
	"breadcrumb": `EPC_breadcrumb__OSFtp`,
	"bcActive": `EPC_bcActive__9a3dU`,
	"bcInactive": `EPC_bcInactive__KISm5`,
	"bcSep": `EPC_bcSep__40zps`,
	"actionGrid": `EPC_actionGrid__Cj7Q6`,
	"actionCard": `EPC_actionCard__LXHIu`,
	"actionArrow": `EPC_actionArrow__4WbUZ`,
	"actionIconWrap": `EPC_actionIconWrap__HzUrY`,
	"actionCardBody": `EPC_actionCardBody__YGI2L`,
	"actionTitle": `EPC_actionTitle__OfnpN`,
	"actionDesc": `EPC_actionDesc__nmzpd`,
	"formCard": `EPC_formCard__jMo+r`,
	"formCardHeader": `EPC_formCardHeader__jUukI`,
	"formCardIcon": `EPC_formCardIcon__nYz1E`,
	"formCardTitle": `EPC_formCardTitle__6VTQi`,
	"formCardSub": `EPC_formCardSub__Tb51g`,
	"formBody": `EPC_formBody__oC2Fc`,
	"formBodyHorizontal": `EPC_formBodyHorizontal__aAPqE`,
	"formRow": `EPC_formRow__+PMC-`,
	"formFooter": `EPC_formFooter__glKd3`,
	"field": `EPC_field__ipf+3`,
	"fieldLabel": `EPC_fieldLabel__ev7Am`,
	"req": `EPC_req__dohR0`,
	"emptyOpts": `EPC_emptyOpts__55HKY`,
	"readonlyValue": `EPC_readonlyValue__sHtDM`,
	"readonlyUnit": `EPC_readonlyUnit__-5o8F`,
	"readonlyLoading": `EPC_readonlyLoading__zgYfY`,
	"stopPreview": `EPC_stopPreview__J2YZ9`,
	"stopPreviewItem": `EPC_stopPreviewItem__mvLyT`,
	"native": `EPC_native__7YAQL`,
	"sel": `EPC_sel__0VSId`,
	"srchWrap": `EPC_srchWrap__5fhtc`,
	"srchOpen": `EPC_srchOpen__jEywM`,
	"srchBtn": `EPC_srchBtn__AG2AD`,
	"srchFilled": `EPC_srchFilled__aNwea`,
	"srchPlaceholder": `EPC_srchPlaceholder__TsEHd`,
	"srchVal": `EPC_srchVal__zfh0E`,
	"srchChev": `EPC_srchChev__s9XJ1`,
	"rotated": `EPC_rotated__3t70n`,
	"srchPanel": `EPC_srchPanel__1DSvw`,
	"srchInput": `EPC_srchInput__6IjAM`,
	"srchList": `EPC_srchList__eQedA`,
	"srchEmpty": `EPC_srchEmpty__M6Ws7`,
	"srchItem": `EPC_srchItem__NGXcV`,
	"srchSelected": `EPC_srchSelected__-UxGF`,
	"srchItemMain": `EPC_srchItemMain__rYs4B`,
	"srchItemSub": `EPC_srchItemSub__gVMmI`,
	"srchCheck": `EPC_srchCheck__LdbrQ`,
	"loadingForm": `EPC_loadingForm__RPbju`,
	"spin": `EPC_spin__XQQIT`,
	"successWrap": `EPC_successWrap__eGGi9`,
	"successCard": `EPC_successCard__r1Dmd`,
	"successHeader": `EPC_successHeader__HwSSa`,
	"successIconWrap": `EPC_successIconWrap__6YXtP`,
	"successHeaderText": `EPC_successHeaderText__oCX7j`,
	"successTitle": `EPC_successTitle__8uJBW`,
	"successMsg": `EPC_successMsg__vzNAo`,
	"successMeta": `EPC_successMeta__c6OIM`,
	"successMetaItem": `EPC_successMetaItem__-6i3e`,
	"successMetaDivider": `EPC_successMetaDivider__05kIL`,
	"successMetaLabel": `EPC_successMetaLabel__sh7RK`,
	"successMetaValue": `EPC_successMetaValue__mjRnj`,
	"successActions": `EPC_successActions__j1D+4`,
	"successActionsDivider": `EPC_successActionsDivider__QxEdo`,
	"successActionsSecondary": `EPC_successActionsSecondary__M+mXt`,
	"successActionsPair": `EPC_successActionsPair__972dG`,
	"machineGrid": `EPC_machineGrid__SN09K`,
	"machineCard": `EPC_machineCard__nLjje`,
	"machineCardIconWrap": `EPC_machineCardIconWrap__T9fKF`,
	"machineCardHeader": `EPC_machineCardHeader__HwAs-`,
	"machineCardCode": `EPC_machineCardCode__PhTHK`,
	"machineCardBody": `EPC_machineCardBody__vrg5L`,
	"machineCardName": `EPC_machineCardName__d2zeE`,
	"machineCardActions": `EPC_machineCardActions__eHeBz`,
	"miniActionBtn": `EPC_miniActionBtn__4uGUq`,
	"searchBarContainer": `EPC_searchBarContainer__MJMqR`,
	"searchBarInputWrap": `EPC_searchBarInputWrap__sVEPo`,
	"searchBarIcon": `EPC_searchBarIcon__aie8S`,
	"searchBarInput": `EPC_searchBarInput__F2pmt`,
	"noMachinesFound": `EPC_noMachinesFound__gHhpM`,
	"producingPartText": `EPC_producingPartText__K4v+O`,
	"producingPartTextSingle": `EPC_producingPartTextSingle__H1oH5`
};
export default ___CSS_LOADER_EXPORT___;
